import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { LoginService } from '../services/LoginService';
import { PATIENT_API } from '../ApiNames';
import { useDispatch } from 'react-redux';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer, FUNDING } from "@paypal/react-paypal-js";
import FinaceofficerLayout from '../layout/finaceofficerlayout/FinaceofficerLayout';
import useEffectOnce from '../hooks/useEffectOnce';
import { Button } from 'primereact/button';
export const MobPayPal = () => {
  const [searchParams] = useSearchParams();
  //   const uid = window.sessionStorage.getItem('uid');
  const uid = searchParams.get('uid');
  console.log('uid', uid)
  const doctorid = searchParams.get('doctorid');
  const hospitalid = searchParams.get('hospitalid');
  const countryid = searchParams.get('countryid');
  const specialityid = searchParams.get('specialityid');
  const desc = searchParams.get('sicknessdesc');
  const SicknessID = searchParams.get('sicknessid');
  const [userData, setUserData] = useState<[]>([]);
  const dispatch = useDispatch();
  const fetchSpeciality = async () => {
    try {
      const payload = { userid: uid, doctorid: doctorid };
      const apiname = PATIENT_API.count_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [userData1, setUserData1] = useState<[]>([]);
  const [amount, setAmount] = useState('');
  const fetchSickness = async () => {
    try {
      const payload = { doctorid: doctorid, q: 1 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData1(response);
      setAmount(response[0].amount);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [Sickness, setSickness] = useState('');
  const [sicknessDes, setSicknessDes] = useState('');
  // const [SickID, setSickID] = useState<any>('');
  const [userData2, setUserData2] = useState<[]>([]);
  const fetchDocDetails = async () => {
    try {
      const payload = { specialityid: specialityid, q: 2 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData2(response);
      const SickID = response[0]?.SickID;
      // if (SickID) {
      //   fetchSickDes(SickID);
      // }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //for panel
  const [userData3, setUserData3] = useState<[]>([]);
  const fetchSickDes = async () => {
    try {
      const payload = { sicknessid: SicknessID, q: 4 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchSickness();
    fetchDocDetails();
    fetchSpeciality();
    fetchSickDes();
  }, [dispatch]);

  const createOrder = (data: any, actions: any) => {
    console.log("actions", actions)
    return actions.order.create({
      purchase_units: [{
        amount: {
          currency_code: "USD", value: amount
        }
      }]
    });
  };
  const navigate = useNavigate();
  // var insert={
  //   "uid":this.uid,
  //   "doctorid":this.doctorid,
  //   "sickness":this.sickness,
  //   "amount":this.amount,
  //   "sicknessdesc":this.sicknessdesc,
  //   "q":q
  // }
  const [Speciality, setSpeciality] = useState('');
  const onApprove = (data: any, actions: any) => {
    return actions.order.capture().then((details: any) => {
      let apiname = '/ws_an_doctordetails.php'
      // console.log(total,"amount")
      const paymentDetails = { uid: uid, doctorid: doctorid, sickness: SicknessID, sicknessdesc: desc, amount: amount, q: 3 };
      LoginService.getData(apiname, paymentDetails)
        .then(() => {
          navigate(`/mobcaseslist/${uid}`);
        });
    });
  };
  const ButtonWrapper = ({ showSpinner }: { showSpinner: boolean }) => {
    const [{ isPending }] = usePayPalScriptReducer();
    console.log(isPending, "pending")
   
    return (
      <>
        {(showSpinner && isPending) && <div className="spinner" />}
        <PayPalButtons forceReRender={[2, "USD"]}
          style={{ layout: 'vertical' }}
          createOrder={createOrder}
          className='paypal-buttons'
          onApprove={onApprove}
          fundingSource={FUNDING.PAYPAL}
        />
      </>
    );
  };

 //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/mobpaypal.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
      event.preventDefault();
      const newWindowReference = window.open(
        targetUrl,
        'newwindow',
        'width=1000,height=1000,noopener,noreferrer'
      );

      if (newWindowReference) {
        newWindowReference.opener = null;
      }
    };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1 style={{ textAlign: 'start' }}>Enter Case Details</h1>
                  </div>
                  <div className="col-3">
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section className="content">
              <div className="container-fluid">
                <div className="grid">
                  <div className="col-4">
                    {userData1.map((response: any, index: any) => (
                      <Card header="" style={{ width: '320px', marginTop: '20px' }}>
                        <div
                          className="widget-user-header bg-info"
                          style={{
                            height: '120px',
                            backgroundColor: 'rgb(23, 162, 184)',
                            display: 'flex',
                            alignItems: 'center',
                            width: '115%',
                            marginLeft: '-21px',
                            marginTop: '-40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                          }}
                        >
                          <img
                            src={response.photo}
                            alt="User Avatar"
                            style={{
                              width: '110px',
                              height: '80px',
                              borderRadius: '50%',
                              padding: '3px',
                              backgroundColor: 'rgb(23, 162, 184)',
                              marginRight: '15px',
                              color: 'white',
                              marginLeft: '20px',
                              border: '3px solid #adb5bd',
                            }}
                          />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <h2
                              className="widget-user-username"
                              style={{
                                color: 'white',
                                fontWeight: '200',
                                fontSize: '25px',
                                marginBottom: '10px',
                              }}
                            >
                              {response.FirstName}
                            </h2>
                            <h3
                              className="widget-user-username"
                              style={{
                                color: '#6c757d',
                                fontSize: '1rem',
                                margin: '0',
                                fontWeight: '400',
                              }}
                            >
                              Doctor
                            </h3>
                          </div>
                        </div>

                        {[
                          { label: 'Speciality', value: response.SpecilityName, bgColor: 'rgb(23, 162, 184)' },
                          { label: 'Country', value: response.CountryName, bgColor: 'rgb(40, 167, 69)' },
                        ].map((item, index) => (
                          <React.Fragment key={index}>
                            <div
                              className="grid"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '0px',
                              }}
                            >
                              <strong
                                style={{
                                  width: '100px',
                                  fontWeight: '500',
                                  textAlign: 'left', marginLeft: '20px',
                                  marginTop: '-5px',
                                }}
                              >
                                {item.label}
                              </strong>
                              <p
                                className="text-muted"
                                style={{
                                  backgroundColor: item.bgColor,
                                  color: 'white',
                                  borderRadius: '6px',
                                  textAlign: 'center',
                                  marginLeft: '15px',
                                  padding: '5px 10px',
                                  display: 'inline-block',
                                }}
                              >
                                {item.value}
                              </p>
                            </div>
                          </React.Fragment>
                        ))}

                      </Card>
                    ))}
                  </div>
                  <div className="col-8">
                    <div>
                      <h4 style={{ textAlign: 'start' }}>Payment Form</h4>
                      <hr
                        style={{
                          width: '116%',
                          border: '0.5px solid rgba(0, 0, 0, 0.1)',
                          margin: '-8px 0',
                          marginLeft: '-20px'
                        }}
                      />
                    </div>

                    <div className="flex align-items-center mb-3" style={{ marginTop: '50px' }}>
                      <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px', }}>Sickness List:</label>
                      <InputText id="nameoforg" type="text" placeholder="Enter Sickness" value={desc} onChange={(e) => setSicknessDes(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                    </div>
                    <div className="flex align-items-center mb-3">
                      <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Sickness:</label>
                      <InputText id="nameoforg" type="text" placeholder="Enter Sickness" value={desc} onChange={(e) => setSicknessDes(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                    </div>
                    <div className="grid" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
                      <div className="col-5"></div>
                      <h4 style={{ textAlign: 'center', marginRight: '0px', color: '#666' }}>To create a case, click the PayPal button</h4>
                      <div className="col-6" style={{ textAlign: 'center' }}>
                        <h2 style={{ color: '#666', marginTop: '-30px' }}>PayPal button is loading</h2>
                        <div style={{ maxWidth: "50px", minHeight: "20px", margin: '0 auto' }}>
                          <PayPalScriptProvider options={{ clientId: "ARnY6ALjQgUvySoBshDMM0wurCnqMzLYNfq13FU8mxtetSe5gV1vJgF5rsXD9jlDQk3YaB4zCw8YfeqM", currency: "USD" }}>
                            <ButtonWrapper showSpinner={false} />
                          </PayPalScriptProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div >
            </section >
          </div >
        </div>
      </div>
    </div>
  )
}